import React, { useState } from 'react'
import moment from 'moment'

import './styles.scss'
import { deleteManagerAPI, apiConversation } from 'api'
import ActivityMsg from 'components/Chat/ActivityMsg'
import PostReplies from './PostReplies'
import PostComment from './PostComment'
import { lang } from 'utils/helpers'
import { toastMessage } from 'utils/messages'

const ChatChannelPost = ({ comment, operator, activitiesTypes, labels }) => {
  const [saveLabelsRefreshCount, setSaveLabelsRefreshCount] = useState(0)

  const handleSaveLabels = (params = {}) => {
    const { userId, messageId, labels } = params

    apiConversation.categories.updateAllConversationMessagesCategories({
      userId,
      messageId,
      categories: labels?.length ? labels.map(({ value }) => value) : []
    })
      .catch(() => {
        setSaveLabelsRefreshCount(prevState => prevState + 1)
        toastMessage(lang('dashboard_error-saving-labels'), 'error', { position: 'top-right' })
      })
  }

  const handleDeleteComment = async ({ commentId, userId }) => {
    try {
      await deleteManagerAPI.deleteComment({ userId, messageId: commentId })
    } catch(error) {
      toastMessage(lang('error_message_delete'), 'error', { position: 'top-right' })
    }
  }

  const getTime = (time) => {
    return moment(time).format('DD-MM-YYYY HH:mm:ss')
    /* const minutes = new Date(time).getMinutes()
    if (minutes < 1) return '<1m'
    if (minutes >= 1 && minutes < 59) return `${Math.trunc(minutes)}m`
    if (minutes >= 60 && minutes < 1439) return `${Math.trunc(minutes / 60)}h`
    if (minutes >= 1440) return `${Math.trunc(minutes / 1440)}d` */
  }

  const getCommentRepliesNodes = ({ level, replies }) => {
    const commentRepliesNodes = []

    for (const reply of replies) {
      if (reply.actionDetailList?.length) {
        commentRepliesNodes.push({
          level,
          node: (
            <PostReplies
              key={reply._id}
              level={level + 1}
              reply={reply}
              operator={operator}
              labels={labels}
              getTime={getTime}
              getCommentRepliesNodes={getCommentRepliesNodes}
              handleSaveLabels={handleSaveLabels}
              saveLabelsRefreshCount={saveLabelsRefreshCount}
            />
          )
        })
      } else {
        commentRepliesNodes.push({
          level,
          node: (
            <PostComment
              childBranch
              key={reply._id}
              id={reply._id}
              userId={reply.user}
              messageId={reply.messageId}
              operatorId={operator._id}
              type={reply.type}
              avatar={reply.postedBy?.photoURL}
              name={reply.postedBy?.name}
              profile={reply.postedBy?.profileURL}
              sentiment={reply.sentiment}
              sentimentList={reply.sentimentList}
              content={reply.messageContent}
              reactions={reply.channel === 'instagram_post'
                ? reply.likeCount ? [{ totalCount: reply.likeCount, typeReaction: 'LOVE' }] : []
                : reply.reactionsFB || []
              }
              time={getTime(reply.createdAt || reply.updatedAt)}
              labels={labels}
              assignedLabels={reply.categories}
              channel={reply.channel}
              handleDeleteComment={handleDeleteComment}
              isRemoved={reply.isRemoved || false}
              handleSaveLabels={handleSaveLabels}
              saveLabelsRefreshCount={saveLabelsRefreshCount}
            />
          )
        })
      }
    }

    return commentRepliesNodes
  }

  if (activitiesTypes.includes(comment.type)) {
    return (
      <ActivityMsg
        id={comment._id}
        avatar={comment.postedBy?.photoURL}
        name={comment.postedBy?.name || comment.postedBy?.email}
        activityData={{
          type: comment.type,
          text: comment.messageContent?.messageText,
          insertBy: comment.insertBy,
          metadata: comment.metadata,
          assignedTo: comment.assignedTo,
          state: comment.state,
          brandName: comment.brandName,
          delegationName: comment.delegationName,
          date: comment.updatedAt
        }}
      />
    )
  }

  return (
    <div className={`chat-channel-post ${comment.type ? comment.type : ''}`}>
      {comment.type !== 'note' ? (
        <PostReplies
          level={1}
          reply={comment}
          operator={operator}
          labels={labels}
          getTime={getTime}
          getCommentRepliesNodes={getCommentRepliesNodes}
          handleSaveLabels={handleSaveLabels}
          saveLabelsRefreshCount={saveLabelsRefreshCount}
        />
      ) : (
        <PostComment
          id={comment._id}
          userId={comment.user}
          messageId={comment.messageId}
          operatorId={operator._id}
          type={comment.type}
          avatar={comment.postedBy?.photoURL}
          name={comment.postedBy?.name}
          profile={comment.postedBy?.profileURL}
          sentiment={comment.sentiment}
          sentimentList={comment.sentimentList}
          content={comment.messageContent}
          time={getTime(comment.createdAt || comment.updatedAt)}
          labels={labels}
          assignedLabels={comment.categories}
          channel={comment.channel}
          handleDeleteComment={handleDeleteComment}
          isRemoved={comment.isRemoved || false}
          handleSaveLabels={handleSaveLabels}
          saveLabelsRefreshCount={saveLabelsRefreshCount}
        />
      )}
    </div>
  )
}

export default ChatChannelPost
